import {sets} from "../data/sets";

export const findIcon = (setCode) => {
    console.debug(setCode)
    return sets.find(s => s.code === setCode)?.icon_svg_uri
}

export const findName = (setCode) => {
    console.debug(setCode)
    return sets.find(s => s.code === setCode)?.name
}
